export const CONTACT = {
  email: "chroma.collectif@gmail.com",
  instagram: { label: "instagram.com/chromalyon", url: "https://instagram.com/chromalyon" },
  soundcloud: { label: "soundcloud.com/chroma-69", url: "https://soundcloud.com/chroma-69" },
  legal: {
    name: "Association Chroma",
    address: "107 quai Pierre-Scize, 69005 Lyon, France",
    rna: "W691109890",
    siret: "945 218 592 00018",
  },
};

export const NAV_LINKS = [
  { to: "/", label: "Accueil", testid: "nav-link-accueil" },
  { to: "/notre-mission", label: "Notre mission", testid: "nav-link-mission" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export const GENRES = [
  "Latin Techno",
  "Hard Bounce",
  "Latincore",
  "Schranz",
  "Cumbia Digitale",
  "Changa Tuki",
  "Baile Funk",
  "Latin Trance",
  "Tech House",
];

export const TEAM = [
  {
    slug: "franco-anselmo",
    name: "Franco Anselmo",
    role: "Co-fondateur",
    photo: "/assets/team-franco.jpg",
    alt: "Portrait de Franco Anselmo, co-fondateur de Chroma",
  },
  {
    slug: "andres-contreras",
    name: "Andrés Contreras",
    role: "Co-fondateur / Directeur artistique / DJ",
    photo: "/assets/team-andres.jpg",
    alt: "Portrait d'Andrés Contreras, co-fondateur et directeur artistique de Chroma",
  },
  {
    slug: "camilo-pino",
    name: "Camilo Pino",
    role: "Photographe / DJ",
    photo: "/assets/team-camilo.jpg",
    alt: "Portrait de Camilo Pino, photographe et DJ de Chroma",
  },
  {
    slug: "antonella-quintieri",
    name: "Antonella Quintieri",
    role: "Social media",
    photo: "/assets/team-antonella.jpg",
    alt: "Portrait d'Antonella Quintieri, social media de Chroma",
  },
  {
    slug: "nirvana-guerra",
    name: "Nirvana Guerra",
    role: "Logistique & ingénieure du son / DJ",
    photo: "/assets/team-nirvana.jpg",
    alt: "Portrait de Nirvana Guerra, logistique et ingénieure du son de Chroma",
  },
];

export const RESIDENTS = [
  {
    slug: "akkelarre",
    index: "R.01",
    origin: "Santiago, Chili → Lyon",
    name: "Akkelarre",
    photo: "/assets/resident-akkelarre.jpg",
    alt: "Akkelarre, artiste résident de Chroma, dans un tunnel éclairé",
    genres: ["Hard Techno", "Hard Bounce", "Latin Trance"],
    instagram: "https://www.instagram.com/akkelarre.dj/",
    sets: [
      { label: "Set Hard Bounce", url: "https://on.soundcloud.com/2VM0q4aaBAKSClw4O6" },
      {
        label: "Set Hard Latin Techno",
        url: "https://soundcloud.com/akkelarre/hard-latin-techno-by-akkelarre",
      },
    ],
    bio: [
      "Originaire de Santiago du Chili et aujourd'hui basé à Lyon, Andrés pose les bases de son parcours musical comme bassiste dans un groupe de rock/metal. Cette première immersion dans un univers de sons puissants et énergiques éveille une curiosité sans fin, qui le mène du reggaeton au rap et à la trap — avant de trouver sa véritable identité dans la musique électronique. De ce chemin éclectique naît son alias, Akkelarre : le reflet d'un univers où les influences se croisent et se fusionnent.",
      "Sous ce nom, il développe un son unique, mêlant l'énergie du hard bounce et de la trance à des rythmiques de reggaeton contagieuses. Un style hybride, encore rare sur la scène française, qui électrise les foules et fait vivre les nuits jusqu'à l'aube. Avec des sorties sur des labels espagnols et le soutien d'artistes de la scène bounce/trance comme Bérou, Betïses, DJ Kinner ou DJ Oslo, Akkelarre s'impose progressivement sur la scène européenne.",
    ],
  },
  {
    slug: "kaplab",
    index: "R.02",
    origin: "San Carlos, Chili → Lyon",
    name: "KAPLAB",
    photo: "/assets/resident-kaplab.jpg",
    alt: "KAPLAB, artiste résident de Chroma, en pleine performance",
    genres: ["Techno", "Latincore", "Schranz"],
    instagram: "https://www.instagram.com/kaplab_krzh/",
    sets: [
      { label: "Set Latincore", url: "https://on.soundcloud.com/vj7gw8fucBkEQPEA5K" },
      { label: "Set Schranz", url: "https://on.soundcloud.com/qnLupgm5IdiFoqVjIe" },
    ],
    bio: [
      "Originaire de San Carlos, au Chili, KAPLAB navigue entre deux extrêmes d'une même intensité. D'un côté, un univers schranz dur et percutant : des sets rapides, sombres, chargés d'une énergie brute, dans la veine d'O.B.I., Viper XXL ou Klangkuenstler. Rythmes implacables, kicks distordus, tension constante — le public reste scotché du début à la fin.",
      "De l'autre, le latincore : les rythmes latins remodelés par des textures glitch, une intensité digitale et une attitude résolument punk. Ici, le perreo devient audacieux, les beats n'invitent pas au mouvement — ils exigent l'attention. Puisant dans les racines du reggaetón et du dembow, KAPLAB y injecte une sensibilité rave, queer, décoloniale et teintée de noise : le dancefloor devient un espace de libération et d'expression — physique, politique et profondément groovy.",
    ],
  },
  {
    slug: "kunawara",
    index: "R.03",
    origin: "Maracay, Venezuela → Lyon",
    name: "Kunawara",
    photo: "/assets/resident-kunawara.jpg",
    alt: "Kunawara, artiste résidente de Chroma, derrière les platines sous une lumière violette",
    genres: ["Latin Tech House", "Cumbia Digitale", "Changa Tuki"],
    instagram: "https://www.instagram.com/kuna_wara/",
    sets: [
      {
        label: "Chroma session — Live from Macbar",
        url: "https://soundcloud.com/chroma-69/dj_kunawara",
      },
    ],
    bio: [
      "Originaire de Maracay, sur la côte caribéenne du Venezuela, Kunawara apporte au dancefloor une énergie chaleureuse et indomptée. Réalisatrice audiovisuelle, ingénieure du son et passionnée de culture rave, elle passe derrière les platines par la hard et l'acid techno, influencée par des figures comme Candy Cox ou Dave the Drummer. Très vite, un besoin viscéral d'exprimer son identité la pousse à fusionner les sonorités afro-latines avec des textures électroniques brutes.",
      "Le résultat : une sélection méticuleuse de pépites underground, entre cumbia digitale, changa tuki, tech house et baile funk. En live, Kunawara manipule le son avec précision, toujours avec intensité et joie — un dialogue entre rythmes tropicaux, basslines lourdes et kicks sales. Ses sets irradient la chaleur et révèlent un groove indompté qui saisit le corps par les hanches.",
    ],
  },
];
